import {
  getTranslatedText,
  TabsContainer,
  useUserMSPCheckHook,
  useIsAuthorisedHook,
  useActivityTracker
} from '@nile/components';
import Insights from '@nile/mangifera/src/Containers/PageContainers/Insights';
import AuditLogs from '@nile/mangifera/src/Containers/PageContainers/AuditLogs.tsx';
import React, { useState } from 'react';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { useIntl } from 'react-intl';
import { TextStyle } from '@superops/ui-design-system';
import { useFlags } from 'launchdarkly-react-client-sdk';

function TabContent(props) {
  return (
    <div className="flex g8 center mb-2">
      <div className="tab-text flex center">
        <TextStyle>{props.content}</TextStyle>
      </div>
    </div>
  );
}

const getTabContent = (title) => {
  const intl = useIntl();
  const translatedTitle = getTranslatedText(intl, title);
  return <TabContent content={translatedTitle} />;
};

const TicketInsightsAndAudit = (props) => {
  const {
    ticket,
    updatedRequester,
    refetchTicket,
    openRequesterSheet,
    getItemsToInvoice,
    updateSelection
  } = props;

  const isMSP = useUserMSPCheckHook();
  const flags = useFlags();

  const ticketsViewPermission = useIsAuthorisedHook('tickets.view');
  const serviceCatalogAuthorised = useIsAuthorisedHook('serviceCatalog.view');
  const isTicketEditAuthorised = useIsAuthorisedHook('tickets.edit');
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  const switchTabIndex = (idx) => {
    if (ticketInsightsAndAuditTabs?.[idx]?.id === 'auditLog') {
      useActivityTracker({ event: 'Ticket audit log - ticket details page.' });
    }
    setActiveTabIndex(idx);
  };

  const redirectToWorklogs = () => {
    setActiveTabIndex(1);
  };

  const ticketInsightsAndAuditTabs = [
    {
      id: 'insights',
      content: getTabContent('common.insights'),
      iconName: 'TicketInsights',
      accessibilityLabel: 'Insights',
      panelID: 'ticket-insights',
      component: (
        <Insights
          ticket={ticket}
          updatedRequester={updatedRequester}
          refetchTicket={refetchTicket}
          openRequesterModal={openRequesterSheet}
          mode="insights"
          redirectToWorklogs={redirectToWorklogs}
          getItemsToInvoice={getItemsToInvoice}
          updateSelection={updateSelection}
        />
      )
    },
    {
      id: 'worklog',
      content: getTabContent('ticket.details.worklog.header'),

      iconName: 'Worklog',
      accessibilityLabel: 'worklog',
      panelID: 'ticket-worklog',
      authorised:
        isMSP &&
        ticketsViewPermission &&
        isTicketEditAuthorised &&
        serviceCatalogAuthorised,
      component: (
        <Insights
          ticket={ticket}
          updatedRequester={updatedRequester}
          refetchTicket={refetchTicket}
          openRequesterModal={openRequesterSheet}
          mode="worklog"
          getItemsToInvoice={getItemsToInvoice}
        />
      )
    },
    {
      id: 'auditLog',
      content: getTabContent('common.auditLog'),
      iconName: 'SupportAccess',
      accessibilityLabel: 'AuditLog',
      panelID: 'ticket-audit-log',
      authorised: isMSP && ticketsViewPermission,
      component: (
        <AuditLogs
          ticket={ticket}
          updatedRequester={updatedRequester}
          refetchTicket={refetchTicket}
          openRequesterModal={openRequesterSheet}
          getItemsToInvoice={getItemsToInvoice}
        />
      )
    }
  ].filter((tab) => {
    if ('authorised' in tab) {
      return tab?.authorised;
    }
    return true;
  });

  const FilteredTicketInsightsAndAuditTabs = ticketInsightsAndAuditTabs.filter(
    (tab) => {
      if (tab?.flag) {
        return flags[tab?.flag];
      }
      return true;
    }
  );

  return (
    <div className="full-height ticket-insights-tabs ghost-white">
      <TabsContainer
        adjustHeight
        onTabChange={switchTabIndex}
        activeTabIndex={activeTabIndex}
        tabs={FilteredTicketInsightsAndAuditTabs}
        noShadow
      />
    </div>
  );
};

export default TicketInsightsAndAudit;
